import { FormEvent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';

type Note = { id: number; content: string; created_at: string };

export default function ProjectPerso() {
  const { id: projectId } = useParams<{ id: string }>();
  const [notes, setNotes] = useState<Note[]>([]);
  const [draft, setDraft] = useState('');

  async function refresh() {
    if (!projectId) return;
    const r = await api.get<{ notes: Note[] }>(`/projects/${projectId}/private-notes`);
    setNotes(r.notes);
  }
  useEffect(() => {
    refresh();
  }, [projectId]);

  async function add(e: FormEvent) {
    e.preventDefault();
    if (!draft.trim() || !projectId) return;
    await api.post('/private-notes', {
      content: draft.trim(),
      project_id: Number(projectId),
    });
    setDraft('');
    refresh();
  }

  async function remove(id: number) {
    await api.del(`/private-notes/${id}`);
    refresh();
  }

  return (
    <>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-meta">
          Cet espace est <strong>privé</strong> — personne d'autre ne le voit.
        </div>
      </div>
      <form className="card" onSubmit={add} style={{ marginBottom: 16 }}>
        <div className="field">
          <label>Nouvelle note</label>
          <textarea
            rows={3}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Question à préparer, observation, brouillon…"
          />
        </div>
        <button className="btn btn-primary">Ajouter</button>
      </form>

      {notes.length === 0 && <div className="card card-meta">Aucune note pour l'instant.</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {notes.map((n) => (
          <div key={n.id} className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="card-meta">{new Date(n.created_at).toLocaleString('fr-FR')}</div>
              <button className="btn btn-ghost" style={{ padding: '4px 10px' }} onClick={() => remove(n.id)}>
                Supprimer
              </button>
            </div>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 6 }}>{n.content}</div>
          </div>
        ))}
      </div>
    </>
  );
}
